import { matchPath } from "react-router-dom";
import routes from "../routes";

const SEGMENT_SEPARATOR = /\s+[>/]\s+/;

export function lastTitleSegment(title) {
  const segments = String(title || "")
    .split(SEGMENT_SEPARATOR)
    .map(segment => segment.trim())
    .filter(segment => segment && !segment.startsWith(":"));
  return segments.length ? segments[segments.length - 1] : "";
}

const ROOT_ROUTE_KEYS = new Set(["classes", "settings", "studentProfile"]);

export function menuTitleCrumbIndex(crumbs) {
  if (!Array.isArray(crumbs) || !crumbs.length) return -1;
  let parentIndex = -1;
  crumbs.forEach((crumb, index) => {
    if (index === crumbs.length - 1 || !crumb || !crumb.to || !crumb.routeKey) {
      return;
    }
    if (ROOT_ROUTE_KEYS.has(crumb.routeKey)) return;
    parentIndex = index;
  });
  return parentIndex === -1 ? crumbs.length - 1 : parentIndex;
}

export function crumbLabel(t, crumb, options = {}) {
  if (options.menuTitle) return options.menuTitle;
  if (crumb.routeKey) {
    return lastTitleSegment(t(`shell.route.${crumb.routeKey}`));
  }
  return crumb.labelKey ? t(crumb.labelKey) : "";
}

export function fillPath(template, params = {}) {
  if (!template) return "";
  return template.replace(/:([A-Za-z]+)/g, (_, key) =>
    params[key] == null ? "" : String(params[key])
  );
}

function routeScore(path) {
  const params = (path.match(/:[A-Za-z]+/g) || []).length;
  const staticLength = path.replace(/:[A-Za-z]+/g, "").length;
  return params * 10000 - staticLength;
}

export function findRoute(pathname) {
  const matches = routes
    .map(route => {
      const match = matchPath(pathname, { path: route.path, exact: true });
      if (!match || !match.isExact) return null;
      return { route, params: match.params || {} };
    })
    .filter(Boolean);

  if (!matches.length) return null;

  matches.sort((a, b) => routeScore(a.route.path) - routeScore(b.route.path));
  return matches[0];
}
